import React from "react";
import { Container, Row, Col, Button, Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";   // <-- IMPORTANT

const textVariant = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 }
};

const imageVariant = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 }
};

const Heroslider = () => {
  return (
    <motion.section
      className="hero-wrapper"
      initial="hidden"
      animate="visible"
      transition={{ staggerChildren: 0.25 }}
    >
      <Carousel interval={3500} indicators={true} controls={true} fade={false}>
        
        {/* -------- SLIDE 1 -------- */}
        <Carousel.Item className="slide-animate">
          <Container>
            <Row className="align-items-center">

              <Col md={6} className="text-start ps-5">
                <motion.h5 variants={textVariant} transition={{ duration: 0.8 }} className="slide-subtitle">
                  Green Circle Provide
                </motion.h5>

                <motion.h1 variants={textVariant} transition={{ duration: 0.9 }} className="slide-title">
                  Door To Door Garbage <br /> Collection Service
                </motion.h1>

                <motion.p variants={textVariant} transition={{ duration: 1 }} className="slide-desc">
                  We provide reliable and efficient door-to-door garbage collection
                  services, ensuring a cleaner environment for your community.
                </motion.p>

                <motion.div variants={textVariant} transition={{ duration: 1.1 }}>
                  <Link to="/hazardous-waste-management">
                    <Button className="slide-btn">Read More</Button>
                  </Link>
                </motion.div>
              </Col>

              <Col md={6} className="text-center">
                <motion.img
                  variants={imageVariant}
                  transition={{ duration: 1 }}
                  src="/banner-img-1.png"
                  className="img-fluid slide-image"
                  alt="slide-1"
                />
              </Col>

            </Row>
          </Container>
        </Carousel.Item>

        {/* -------- SLIDE 2 -------- */}
        <Carousel.Item className="slide-animate">
          <Container>
            <Row className="align-items-center">

              <Col md={6} className="text-start ps-5">
                <motion.h5 variants={textVariant} transition={{ duration: 0.8 }} className="slide-subtitle">
                  Green Circle Don’t Just Manage Waste
                </motion.h5>

                <motion.h1 variants={textVariant} transition={{ duration: 0.9 }} className="slide-title">
                  We Provide Solutions <br /> Also
                </motion.h1>

                <motion.p variants={textVariant} transition={{ duration: 1 }} className="slide-desc">
                  Our waste management solutions minimize environmental impact while
                  maximizing efficiency and sustainability.
                </motion.p>

                <motion.div variants={textVariant} transition={{ duration: 1.1 }}>
                  <Link to="/products">
                    <Button className="slide-btn">Read More</Button>
                  </Link>
                </motion.div>
              </Col>

              <Col md={6} className="text-center">
                <motion.img
                  variants={imageVariant}
                  transition={{ duration: 1 }}
                  src="/banner-img-2.png"
                  className="img-fluid slide-image"
                  alt="slide-2"
                />
              </Col>

            </Row>
          </Container>
        </Carousel.Item>

      </Carousel>

      {/* Decorative Elements */}
      <motion.div 
        className="dots-left"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      />
      <motion.div 
        className="dots-right"
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      />
      <motion.img
        src="/recycle.png"
        className="center-icon"
        alt="icon"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
      />
    </motion.section>
  );
};

export default Heroslider;
